<template>
  <v-chip
    :x-small="xSmall"
    :small="!xSmall"
    label
    :color="isStripe ? 'indigo lighten-5' : 'amber lighten-4'"
    :text-color="isStripe ? 'indigo darken-1' : 'brown darken-1'"
    class="payment-provider-chip"
  >
    <v-icon left :size="xSmall ? 12 : 14">{{ isStripe ? 'mdi-credit-card-fast-outline' : 'mdi-bank-transfer' }}</v-icon>
    {{ label }}
  </v-chip>
</template>

<script>
export default {
  name: "PaymentProviderChip",
  props: {
    provider: { type: String, default: "PAYCOMPASS" },
    xSmall: { type: Boolean, default: true },
  },
  computed: {
    isStripe() { return String(this.provider || "").toUpperCase() === "STRIPE" },
    label() { return this.isStripe ? "Stripe" : "PayCompass" },
  },
};
</script>

<style scoped>
.payment-provider-chip { flex: 0 0 auto; font-weight: 700; }
</style>
